import { Profile } from '@/models'

import axios, { withToken } from './axios'

/**
 * Gets Profile details.
 *
 * @param token Valid authentication Token.
 */
export async function fetchProfile (token: string): Promise<Profile> {
  const response = await axios.get(
    '/api/me/profile',
    withToken(token)
  )

  const data = response.data.user // Contains extra properties

  return {
    id: data.id,
    firstName: data.firstName,
    lastName: data.lastName,
    email: data.email,
    isEmailConfirmed: data.emailConfirmed, // Renaming
    phone: data.phone || null,
    picture: data.picture || null
  }
}
